import { Grid } from '@mui/material';
import { Checkbox, HSpacer, RoutalDialog, RoutalDialogProps, VSpacer } from '@nx-smartmonkey/ui';
import { useEffect, useState } from 'react';
import { Translation } from '../../../domain/translation/Translation';
import Button from '../../../react-components/Button';
import InputText from '../../../react-components/InputText';
import Text from '../../../react-components/Text';
import { useUpdateTranslation } from '../hooks/translations/useUpdateTranslation';

interface TranslationUpdateModalProps extends RoutalDialogProps {
  translation: Translation;
  onEditTranslation: () => void;
}

export const TranslationUpdateModal = ({
  open,
  onCloseDialog,
  translation,
  onEditTranslation,
}: TranslationUpdateModalProps) => {
  const [updateAllLanguages, setUpdateAllLanguages] = useState(false);
  const [newValue, setNewValue] = useState<string>(translation.value);
  const { run: updateTranslation, success: updateSuccess, isLoading } = useUpdateTranslation();

  useEffect(() => {
    if (updateSuccess) {
      onEditTranslation();
    }
  }, [updateSuccess, onEditTranslation]);

  return (
    <RoutalDialog
      open={open}
      onCloseDialog={onCloseDialog}
      titleContent={
        <Text
          variant="h6"
          intlId="administration.translations.update.title"
          intlValues={{ translationKey: translation.key }}
        />
      }
      dialogContentWarning={<div />}
      footerContent={
        <Grid>
          <Button
            disabled={isLoading}
            onClick={() => {
              updateTranslation({
                language: translation.language.value,
                key: translation.key,
                value: newValue,
                domain: translation.domain,
                updateOtherLanguages: updateAllLanguages,
              });
            }}
            intlId={isLoading ? `loading` : `confirm`}
          />
        </Grid>
      }
    >
      <Grid display="flex" flexDirection="column">
        <Text variant="body" intlId="administration.translations.value" />
        <VSpacer small />
        <InputText
          fieldValue={newValue}
          disabled={isLoading}
          inputStyles={{ alignContent: `center` }}
          inputContainerStyles={{ background: isLoading ? `#eee` : `transparent` }}
          onChange={(value) => setNewValue(value)}
          multiline={true}
          rowsMin={1}
          disableEnter
        />

        <VSpacer large />

        <Grid display="flex" flexDirection="row" alignItems="center">
          <Checkbox checked={updateAllLanguages} onChange={(_, value) => setUpdateAllLanguages(value)} />
          <HSpacer small />
          <Text
            variant="body"
            intlId="administration.translations.update_all_languages"
            onClick={() => {
              setUpdateAllLanguages((curr) => !curr);
            }}
          />
        </Grid>
      </Grid>
    </RoutalDialog>
  );
};
